import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, aboutParallel, mobileAbout, mobileAboutParallel } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mt="-5px" mb="-5px">
          <CFImage src={about} w="100%" pv="5px" alt="Victoria Pocha About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="600px"
          w="100%"
          image={`url(${about}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
